import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
export default function Fleet() {
    const [value, setValue] = useState('')
    const [formObj, setFormObj] = useState({ customerKeys:[]});
    // const { globalfilter, updateParent,reset, type } = props;

    const [FleetData, setFleetData] = React.useState([]);

    const fetchFleetData = async () => {
        //
      
        // const customerKey = getCookie("clientId");
        // const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/${customerKey}`;

        // await getRequest(url)
        //     .then((res) => {
        //         console.log("Responce", res);
        //         if (res.status == 200) {
        //             //  dispatch({ type: LOADING, payload: false });
        //             let obj = { "currentVesselName": "All" };
        //             let result = res.data;
        //             result.unshift(obj);
        //            // setShipNameData(result);
        //             console.log(shipNameData);
        //         } else {
        //             ToastError(res.data.message);
        //         }
        //     })
        //     .catch((error) => {
        //         // dispatch({ type: LOADING, payload: false });
        //         //console.log(error);
        //         // ToastError(error.response.data.message);
        //     });
    }
    // React.useEffect(() => {
    //     //
    //     if (reset>0)
    //     defaultValue(GlobalFilterSettingValue);
        
    // }, [reset]);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                // fullWidth
                options={FleetData}
                getOptionLabel={(option) =>option.title}
                //defaultValue={[top100Films[13]]}
               
               
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Fleet"
                        //placeholder="Favorites"
                        onChange={fetchFleetData}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

